import { useEffect, useState } from "react";
import { Form, Input, Checkbox, Space, Button, message, Switch } from "antd";
import { CloseOutlined, SaveOutlined } from "@ant-design/icons";
import { serverFetch } from "@server";
import { useViewportBreakpoint } from "../../hooks/useViewportBreakpoint";
import "../company/company.css";

const TaskUser = ({ itemDefault, onClose, companyId }) => {
  const [item, setItem] = useState({ ...itemDefault });
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const isMobile = useViewportBreakpoint() === "mobile";

  useEffect(() => {
    setItem({ ...itemDefault });
    form.setFieldsValue(itemDefault);
  }, [itemDefault, form]);

  const onValuesChange = (_changed, all) => setItem(prev => ({ ...prev, ...all }));

  const onSave = () => {
    form.validateFields().then(values => {
      setLoading(true);
      const merged = { ...item, ...values };
      const body = { ...merged, companyId: companyId ?? merged.companyId };
      serverFetch("plan/dep", { method: merged.id ? "PUT" : "POST", bodyData: body })
        .then(() => onClose(true))
        .catch(e => {
          setLoading(false);
          message.error(e.userMessage);
        });
    });
  };

  const onCancel = () => onClose(false);

  const title = "Исполнитель";

  const formFields = (
    <>
      {isMobile ? (
        <Form.Item label="">
          <div className="company-base-switch-row">
            <span>Активен</span>
            <Form.Item name="active" valuePropName="checked" noStyle>
              <Switch disabled={loading} />
            </Form.Item>
          </div>
        </Form.Item>
      ) : (
        <Form.Item label="Активен" name="active" valuePropName="checked">
          <Checkbox>Активен</Checkbox>
        </Form.Item>
      )}
      <Form.Item label="Телефон/почта" name="userName" rules={[{ required: true, message: "Введите телефон или почту!" }]}>
        <Input placeholder="Телефон или email" />
      </Form.Item>
      <Form.Item label="Наименование" name="name" rules={[{ required: true, message: "Введите наименование!" }]}>
        <Input placeholder="Наименование" />
      </Form.Item>
      {!isMobile && (
        <Form.Item label=" ">
          <Space>
            <Button className="misoft-btn" type="primary" onClick={onSave} loading={loading}>
              Сохранить
            </Button>
            <Button className="misoft-btn" onClick={onCancel}>
              Отмена
            </Button>
          </Space>
        </Form.Item>
      )}
    </>
  );

  return (
    <div>
      <div
        className={`misoft-modal-overlay${isMobile ? " company-base-overlay--mobile" : ""}`}
        onClick={e => e.target === e.currentTarget && onClose(false)}
      >
        <div
          className={`misoft-modal-content${isMobile ? " company-base-sheet--mobile" : ""}`}
          style={isMobile ? undefined : { width: 500 }}
          onClick={e => isMobile && e.stopPropagation()}
        >
          {isMobile ? (
            <>
              <div className="company-base-sheet-header">
                <span className="company-base-sheet-title">{title}</span>
                <Space size="small" className="company-base-sheet-actions">
                  <Button
                    type="primary"
                    icon={<SaveOutlined />}
                    onClick={onSave}
                    loading={loading}
                    aria-label="Сохранить"
                    className="company-base-header-icon-btn"
                  />
                  <Button
                    type="default"
                    icon={<CloseOutlined />}
                    onClick={() => onClose(false)}
                    aria-label="Закрыть"
                    className="company-base-header-icon-btn"
                  />
                </Space>
              </div>
              <div className="company-base-sheet-body">
                <Form
                  form={form}
                  onValuesChange={onValuesChange}
                  layout="vertical"
                  colon={false}
                  disabled={loading}
                  style={{ width: "100%", maxWidth: "100%" }}
                >
                  {formFields}
                </Form>
              </div>
            </>
          ) : (
            <>
              <div className="misoft-modal-title">
                <span>{title}</span>
                <CloseOutlined
                  className="misoft-section-title-close"
                  onClick={() => onClose()}
                  style={{ zIndex: 9, color: "#2f6f00", fontSize: 16 }}
                />
              </div>
              <Form
                form={form}
                onValuesChange={onValuesChange}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 24 }}
                colon={false}
                disabled={loading}
                style={{ maxWidth: 500 }}
              >
                {formFields}
              </Form>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default TaskUser;
